import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MenuButton, WithTooltip } from 'basic-components';
import { Add } from 'basic-components/icons';

import CreateFileButton from 'primary/CreateFileButton';

const CreateFile = ({ onChange }) => {
  const pipelineGroup = useSelector(state => state.datascienceState.creatorState.saveDialogState.groupName?.value || state.datascienceState.creatorState.saveDialogState.groupName),
        userName = useSelector(state => state.myAccountState.settingsState.userName),
        userHomeGroup = `${userName}_home`,
        onSubmitCallback = useCallback(val => onChange(val), [onChange])
        
  return (
    <CreateFileButton
        getMenuButton={() => (
          <MenuButton 
              className="data-science__pipeline-creator__body__options__resolver__header__controls__control"
              key="CreateFile"
          >
            <WithTooltip
                data-place="top"
                short
                text="Create file"
            >
              <div>
                <Add
                    color="blue-bright"
                    height={16}
                    width={16}
                />
              </div>
            </WithTooltip>
          </MenuButton>
        )}
        groupName={pipelineGroup ? String(pipelineGroup).trim() : userHomeGroup}
        onSubmitCallback={onSubmitCallback}
    />
  )
}

CreateFile.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default CreateFile;